import React, {useContext, useEffect, useState} from 'react';
import Container from "@material-ui/core/Container";
import {FloorPlan, Settings} from "../SharedTypes";
import {BackendContext} from "../components/BackendContext";
import {makeStyles} from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import ChevronRight from "@material-ui/icons/ChevronRight";
import CartPage from "./CartPage";
import {Route, Switch, useHistory, useRouteMatch} from "react-router";
import {Link} from "react-router-dom";
import * as H from "history";


const useStyles = makeStyles({
    root: {
        maxWidth: '100%',
    },
    media: {
        display: 'block',
        height: 160,
        margin: 'auto',
    },
    container: {
        marginTop: '2rem'
    },
    logo: {
        maxWidth: 320,
        maxHeight: 80,
    }
});

function FloorPlansListing() {
    const classes = useStyles(),
        [floorPlans, setFloorPlans] = useState<FloorPlan[]>([]),
        [settings, setSettings] = useState<Settings | undefined>(),
        backendApi = useContext(BackendContext),
        history = useHistory();

    useEffect(() => {
        Promise.all([
            backendApi.getFloorPlanOrder(),
            backendApi.listFloorPlans()
        ]).then(([order, floorPlans]) =>
            setFloorPlans(floorPlans.sort((a, b) =>
                order.indexOf(parseInt(a.id as any)) - order.indexOf(parseInt(b.id as any)))));

        backendApi.getSettings().then(setSettings);
    }, [backendApi]);

    const communities = floorPlans.map(p => p.community)
            .filter(function (item, pos, arr) {
                return item.trim() && arr.indexOf(item) === pos;
            }),
        noCommunity = floorPlans.filter(p => !(p.community || '').trim());

    return (
        <Switch>
            <Route path="/:floorPlanName" component={CartRoute}/>
            <Route>
                <Container maxWidth="lg" className={classes.container}>
                    {settings?.logo ? <img src={settings.logo.url} alt={settings.title} className={classes.logo}/>
                        : <Typography component="h1" variant="h4">{settings?.title}</Typography>}

                    {communities.length ? communities.map(c => <React.Fragment key={c}>
                            <Typography component="h2" variant="h5" style={{marginTop: '2rem'}}>{c}</Typography>
                            <Grid container spacing={2} alignItems="flex-end" justify="center" alignContent="center">
                                {floorPlans
                                    .filter(p => p.community === c)
                                    .map(floorPlan => floorPlanCard({floorPlan, classes, history}))}
                            </Grid>
                        </React.Fragment>).concat(noCommunity.length ?
                            [<React.Fragment key="Other">
                                <Typography component="h2" variant="h5" style={{marginTop: '2rem'}}>Other</Typography>
                                <Grid container spacing={2} alignItems="flex-end" justify="center" alignContent="center">
                                    {noCommunity.map(floorPlan => floorPlanCard({floorPlan, classes, history}))}
                                </Grid>
                            </React.Fragment>] : [])
                        : <Grid container spacing={2} alignItems="flex-end" justify="center" alignContent="center">
                            {floorPlans.map(floorPlan => floorPlanCard({floorPlan, classes, history}))}
                        </Grid>}
                </Container>
            </Route>
        </Switch>
    );
}

export default FloorPlansListing;

function CartRoute() {
    const params = useRouteMatch<{ floorPlanName: string }>();

    return <CartPage floorPlanName={params.params.floorPlanName} listingPage="/"/>
}

function floorPlanCard({floorPlan, classes, history}: { floorPlan: FloorPlan, classes: any, history: H.History }) {
    return <Grid item key={floorPlan.id} xs={12} sm={6} md={4}>
        <Card className={classes.root}>
            <CardActionArea onClick={() => history.push(`/${encodeURIComponent(floorPlan.name)}`)}>
                <img src={floorPlan.photo?.url} className={classes.media} alt={floorPlan.name}/>
                <CardContent>
                    <Typography gutterBottom variant="h5" component="h2">
                        {floorPlan.name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" component="p"
                                dangerouslySetInnerHTML={{__html: floorPlan.shortDesc}} style={{minHeight: '1rem'}}/>
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Button size="small" color="primary" endIcon={<ChevronRight/>}
                        component={Link} to={`/${encodeURIComponent(floorPlan.name)}`}>
                    View Plans and Options
                </Button>
            </CardActions>
        </Card>
    </Grid>;
}